var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListViewBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21243_38649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70426 1.5H2.63847C1.88998 1.5 1.2832 2.10677 1.2832 2.85526V6.92105C1.2832 7.66954 1.88998 8.27631 2.63847 8.27631H6.70426C7.45275 8.27631 8.05952 7.66954 8.05952 6.92105V2.85526C8.05952 2.10677 7.45275 1.5 6.70426 1.5Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9279 1.5H11.8621C11.1136 1.5 10.5068 2.10677 10.5068 2.85526V6.92105C10.5068 7.66954 11.1136 8.27631 11.8621 8.27631H15.9279C16.6764 8.27631 17.2832 7.66954 17.2832 6.92105V2.85526C17.2832 2.10677 16.6764 1.5 15.9279 1.5Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70426 10.7236H2.63847C1.88998 10.7236 1.2832 11.3304 1.2832 12.0789V16.1447C1.2832 16.8932 1.88998 17.4999 2.63847 17.4999H6.70426C7.45275 17.4999 8.05952 16.8932 8.05952 16.1447V12.0789C8.05952 11.3304 7.45275 10.7236 6.70426 10.7236Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9279 10.7231H11.8621C11.1136 10.7231 10.5068 11.3299 10.5068 12.0784V16.1442C10.5068 16.8927 11.1136 17.4995 11.8621 17.4995H15.9279C16.6764 17.4995 17.2832 16.8927 17.2832 16.1442V12.0784C17.2832 11.3299 16.6764 10.7231 15.9279 10.7231Z",
    fill: "#CED4DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21243_38649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16,
    fill: "white",
    transform: "translate(1.2832 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewBudget);
export default __webpack_public_path__ + "static/media/listViewBudget.62b69b1352053e6142f37f7cff416181.svg";
export { ForwardRef as ReactComponent };